export const COUNTRY_NAME_EN = 'netherlands';
export const COUNTRY_NAME_NL = 'nederland';
export const ONE_PIXEL_BLURRED_PLACEHOLDER_IMAGE =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mO8Ww8AAj8BXkQ+xPEAAAAASUVORK5CYII=';
export const FALLBACK_AVERAGE_RENTOUT_DAY = 11;
export const FALLBACK_ACTIVE_TENANT_COUNT_NETHERLANDS = 11008;
